const $inject = ['$q', '$http', 'apiService'];

const userProfileService = function ($q, $http, apiService) {
  let service = {};
  service.profile = null;
  service.getPerson = getPerson;
  service.getAny = getAny;
  service.updatePerson = updatePerson;
  service.register = register;
  service.clear = clear;
  service.store = store;

  return service;

  function getAny() {
    if(service.profile) {
      let deferred = $q.defer();
      deferred.resolve(service.profile);
      return deferred.promise;
    } else {
      return getPerson();
    }
  }

  function getPerson() {
    let deferred = $q.defer();
    const apiUrl = apiService.getUrl('userProfile');

    $http.get(apiUrl)
      .then(res => {
        let data = res.data;
        service.profile = data;
        deferred.resolve(service.profile);
      });

    return deferred.promise;
  }

  function updatePerson(profile) {
    let deferred = $q.defer();

    const apiUrl = apiService.getUrl('userProfile');
    const userProfile = profile || service.profile;

    $http.put(apiUrl, userProfile)
      .then(() => {
        service.profile = userProfile;
        deferred.resolve(service.profile);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function register(profile) {
    let deferred = $q.defer();

    const apiUrl = apiService.getUrl('userRegister');

    $http.post(apiUrl, profile)
      .then(() => {
        deferred.resolve();
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function clear() {
    localStorage.removeItem('profile');
  }

  function store(profile) {
    service.profile = profile;
    return service.profile;
  }
};

userProfileService.$inject = $inject;

export default userProfileService;



// WEBPACK FOOTER //
// ./src/services/userProfileService.js